import React, { useState, useEffect } from 'react';
import './AddPujaForm.css';

const AddPujaForm = ({ onClose, onSave, editingPuja }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image_url: '',
    items: []
  });
  const [newItem, setNewItem] = useState({ name: '', quantity: '' });

  useEffect(() => {
    if (editingPuja) {
      setFormData({
        name: editingPuja.name || '',
        description: editingPuja.description || '',
        image_url: editingPuja.image_url || '',
        items: editingPuja.items || []
      });
    }
  }, [editingPuja]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    setNewItem(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const addItem = () => {
    if (newItem.name.trim() && newItem.quantity.trim()) {
      setFormData(prev => ({
        ...prev,
        items: [...prev.items, { ...newItem }]
      }));
      setNewItem({ name: '', quantity: '' });
    }
  };

  const removeItem = (index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name.trim()) {
      onSave(formData);
    }
  };

  return (
    <div className="add-puja-form">
      <div className="form-header">
        <h2>{editingPuja ? '✏️ Edit Puja' : '➕ Add New Puja'}</h2>
        <button onClick={onClose} className="close-button">
          ✕
        </button>
      </div>

      <form onSubmit={handleSubmit} className="puja-form">
        <div className="form-group">
          <label htmlFor="name">Puja Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
            placeholder="Enter puja name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            placeholder="Enter puja description"
          />
        </div>



        <div className="form-group">
          <label>Items Required for Puja</label>

          <div className="item-input-group">
            <input
              type="text"
              name="name"
              value={newItem.name}
              onChange={handleItemChange}
              placeholder="Item name"
              className="item-input"
            />
            <input
              type="text"
              name="quantity"
              value={newItem.quantity}
              onChange={handleItemChange}
              placeholder="Quantity"
              className="item-input"
            />
            <button
              type="button"
              onClick={addItem}
              className="add-item-button"
            >
              Add Item
            </button>
          </div>

          {formData.items.length > 0 && (
            <div className="items-list">
              <h4>Items List:</h4>
              {formData.items.map((item, index) => (
                <div key={index} className="item-row">
                  <span className="item-info">
                    <strong>{item.name}</strong> - {item.quantity}
                  </span>
                  <button
                    type="button"
                    onClick={() => removeItem(index)}
                    className="remove-item-button"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="button" onClick={onClose} className="cancel-button">
            Cancel
          </button>
          <button type="submit" className="save-button">
            {editingPuja ? 'Update Puja' : 'Save Puja'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPujaForm;